module.exports = __webpack_public_path__ + "media/audio41.df67b55b.mp3";